import { FC } from "react";
import UsersContainer from "../../components/containers/UsersContainer";

const UsersPage: FC = () => {
    return (
        <div className="main-admin__content">
            <div className="main-admin__header">
                <h1 style={{ color: "#ffffff", marginBottom: "20px" }}>Пользователи</h1>
            </div>
            <div className="main-admin__filters">
                <div className="main-admin__buttons"></div>
                <div className="main-admin__filters-block"></div>
            </div>

            <UsersContainer />
        </div>
    );
};

export default UsersPage;
